<template>
  <div class="background">
    <div class="container">
      <br />
      <br />
      <br />
      <div class="forgotPasswordComponent display-block shadow p-4">
        <h1 class="title">Not really a problem!</h1>
        <p class="">
          Provide us your <strong>email</strong>, then we gonna send to you a
          <strong>link</strong> to your email inbox to change your
          <strong>password</strong>
        </p>
        <!--<br />-->
        <div v-if="err" class="alert red text-white errMsg">{{ errMsg }}</div>
        <br />
        <input
          type="email"
          placeholder="Enter Your Email"
          class="form-control email"
          name="email"
          v-model="email"
        />
        <br />
        <button
          @click="sendId()"
          class="form-control  primary sendId send btns btn"
        >
          Send Email
        </button>
        <br />
        <br />
        <p class="suggestion">have no account?</p>
        <router-link id="rl" to="/register"
          ><p class="link text-primary">Sign Up</p></router-link
        ><br />
      </div>
      <div class="sucessPage display-none">
        <i
          class="fas fa-6x text-center success-icon text-success fa-check-circle"
        ></i>
        <br />
        <br />
        <h3>
          <h3 class="text-success">We Sucessfully sent an email to</h3>
          <strong class="text-dark">{{ email }}</strong>
        </h3>
        <strong class="text-center">
          NB: your link will gonna get expired after 10 minutes from now! for
          security purposes
        </strong>
      </div>
      <!-- Background Image Owner Account -->
      <!-- <p class="text-white owner-credit text-right">
        Photo by <a href="https://unsplash.com/@chuttersnap">chuttersnap</a> on
        <a href="https://unsplash.com/">Unsplash</a>
      </p>
    --></div>
    <div class="footerApp">
      <footerApp></footerApp>
    </div>
  </div>
</template>

<script>
import footerApp from "../components/footer.vue";
// IMPORT LINKS FILE
const link = require("../.././api.links.config.js");
export default {
  name: "forgotPassword",

  data() {
    return {
      token: window.localStorage.getItem("access-token") || false, // TOKEN
      email: null,
      errMsg: null,
      err: false
    };
  },
  components: {
    footerApp
  },
  created() {
    // SET SCROLL LEVEL TO 0 WHICH MEANS TO THE TOP
    window.scrollTo(0, 0);
    // auth stuff goes here...
    if (this.token) {
      this.$router.push("/");
    }
  },
  methods: {
    sendId: function() {
      document.querySelector(
        ".sendId"
      ).innerHTML = `<span class="spinner-grow spinner-grow-sm text-dark" role="status" aria-hidden="true"></span>
	        Please Wait...`;

      // VALIADTE EMAIL
      if (!this.email) {
        // SHOW ALERT MESSAGE
        this.errMsg = "Please provide us your email!";
        this.err = true;

        // CHANGE BUTTON BACK CONTENT
        document.querySelector(".sendId").innerHTML = `Send Email`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      } else if (
        this.email.includes("@") &&
        this.email.includes(".") &&
        this.email.length > 7
      ) {
        //  INIT BODY DATA
        const body = { email: this.email };

        this.$http
          .post(link.baselink + "/auth/sendemail", body)
          .then(res => {
            if (res.data.sended === true) {
              // HIDE THE FORM AND SHOW SUCESS COMPONENT
              document
                .querySelector(".forgotPasswordComponent")
                .classList.add("display-none");
              document
                .querySelector(".forgotPasswordComponent")
                .classList.remove("display-block");
              document
                .querySelector(".sucessPage")
                .classList.add("display-block");
              document
                .querySelector(".sucessPage")
                .classList.remove("display-none");
            } else {
              // SHOW ALERT MESSAGE
              this.errMsg = "Somthing wrong happened";
              this.err = true;

              // CHANGE BUTTON BACK CONTENT
              document.querySelector(".sendId").innerHTML = `Send Email`;

              // HIDE ALERT AFTER 3 SECONDS
              window.setInterval(() => {
                this.errMsg = null;
                this.err = false;
              }, 5000);
            }
          })
          .catch(() => {
            // SHOW ALERT MESSAGE
            this.errMsg =
              "Something unexpectedly happened to our server! try again.";
            this.err = true;

            // CHANGE BUTTON BACK CONTENT
            document.querySelector(".sendId").innerHTML = `Send Email`;

            // HIDE ALERT AFTER 3 SECONDS
            window.setInterval(() => {
              this.errMsg = null;
              this.err = false;
            }, 5000);
          });
      } else {
        // SHOW ALERT MESSAGE
        this.errMsg = "Please provide us your a valid email!";
        this.err = true;

        // CHANGE BUTTON BACK CONTENT
        document.querySelector(".sendId").innerHTML = `Send Email`;

        // HIDE ALERT AFTER 3 SECONDS
        window.setInterval(() => {
          this.errMsg = null;
          this.err = false;
        }, 5000);
      }
    }
  }
};
</script>

<style lang="css" scoped>
.title {
  color: var(--bg-color);
}
.background {
  /*background-image: url('.././assets/atul-vinayak-hZioHCEWSAE-unsplash.jpg'); /*Photo by Atul Vinayak on Unsplash  Mt Fuji */
  /*background-image: url(".././assets/chuttersnap-C4Lrq1F3vDQ-unsplash.jpg"); /*Photo by chuttersnap on Unsplash koalalampur city*/
  /* background-image: url('.././assets/owen-lystrup-boLgiM0qwkg-unsplash.jpg');*/ /*Photo by Owen Lystrup on Unsplash city in us */
  background-attachment: ;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  height: 100vh;
}
.owner-credit {
  margin-top: 12%;
}
.forgotPasswordComponent {
  border-radius: 3px;
  width: 40%;
  margin: 0 auto;
  background-color: white;
  position: relative;
  top: 30%;
  opacity: 0.9;
  transition: all 0.2s ease-out;
}
/*.forgotPasswordComponent:hover {
  opacity: .9;
}*/
.suggestion {
  color: var(--bg-color);
  font-weight: 100;
  font-size: 12px;
  display: inline;
  padding: 3px;
}
.link {
  font-weight: 100;
  font-size: 12px;
  display: inline;
  padding: 3px;
}
input {
  font-size: 13px;
}
.display-none {
  display: none !important;
}
.display-block {
  display: block !important;
}
.red {
  background-color: var(--dan-ger);
}
.primary {
  background-color: var(--primary-color);
}
.none {
  display: none;
}
.block {
  display: block;
}
.inline {
  display: inline;
}
.sucessPage {
  padding-top: 10%;
}
/*.success-icon {
  border-radius: 55px;
}/*/
.footerApp {
  margin-top: 100px;
}
@media only screen and (max-width: 600px) {
  .forgotPasswordComponent {
    width: 100%;
  }
  .title {
    font-size: 30px !important;
  }
}
</style>
